import { render, staticRenderFns } from "./SimpleLoader.vue?vue&type=template&id=64f1ec82&scoped=true"
import script from "./SimpleLoader.vue?vue&type=script&lang=js"
export * from "./SimpleLoader.vue?vue&type=script&lang=js"
import style0 from "./SimpleLoader.vue?vue&type=style&index=0&id=64f1ec82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f1ec82",
  null
  
)

export default component.exports